import { type RouteObject } from 'react-router-dom';

import { requirePermissions } from '@/app/requirePermissions';
import { isFeatureEnabled } from '@/lib/featureFlags';
import { PagePermissions } from '@/models/pagePermissions';

const routes: RouteObject = {
  path: 'import',
  loader: requirePermissions({ oneOf: PagePermissions.sandboxImport }),
  lazy: () => import('./sandboxImport'),
};

export const sandboxImportRoute: RouteObject = isFeatureEnabled('import-v2')
  ? routes
  : {};
